module.exports = __webpack_public_path__ + "img/mars-stroke-h.bcba2acc.svg";